module.exports = __webpack_public_path__ + "static/images/b8755a27da19e0bf21dbd9b49c1edd76.png";